import React from 'react';

export default ({ i18n }) => ({
  key: 'shared',
  name: i18n.getString(_TL_('Shared')),
  fieldName: 'Type',
  minWidth: 70,
  maxWidth: 90,
  isResizable: true,
  sortable: true,
  data: 'number',
  onRender: (item) => {
    const { Type } = item;
    return <span>{i18n.getString(Type === 'ReportUITemplate' ? _TL_('No') : _TL_('Yes'))}</span>;
  },
});
